import c from 'classnames';
import { IconChevronLeft, IconChevronRight } from 'featherico';
import moment from 'moment';
import styles from './styles.m.less';

interface Props {
    month: string; // YYYY-MM
    onPrevMonthClick?: () => void;
    onNextMonthClick?: () => void;
}

export default function Navigation({ onPrevMonthClick, onNextMonthClick, month }: Props) {
    return (
        <div className={styles.container}>
            <div className={styles.currentMonth}>{moment(month, 'YYYY-MM').format('MMMM YYYY')}</div>

            <div>
                <button
                    type="button"
                    className={c(styles.arrow)}
                    onClick={onPrevMonthClick}
                    disabled={!onPrevMonthClick}
                    title="Previous month"
                    tabIndex={-1}
                >
                    <IconChevronLeft />
                </button>

                <button
                    type="button"
                    className={c(styles.arrow, styles.arrowRight)}
                    onClick={onNextMonthClick}
                    disabled={!onNextMonthClick}
                    title="Next month"
                    tabIndex={-1}
                >
                    <IconChevronRight />
                </button>
            </div>
        </div>
    );
}
